import { inject } from '@angular/core';
import { BusinessService } from '../../services/business';
import { AuthService } from '../../services/auth';
import { PreloaderService } from '../services/preloader.service';
import { ToastService } from '../services';
import { isBefore } from 'date-fns';
import { collectFormMessages, FieldLabels, firstInvalidControlName } from './formValidHelper';
import { FormGroup } from '@angular/forms';

export abstract class BaseAuthComponent {
  protected authService = inject(AuthService);
  protected preloader = inject(PreloaderService);
  protected toastServiceBase = inject(ToastService);

  // Expose authService to template (public getter)
  get authServicePublic() {
    return this.authService;
  }

  protected get businessId(): string {
    const id = this.authService.getUserInfo()?.business_id;
    if (!id) throw new Error('business_id no disponible todavía');
    return id;
  }

  protected markAllAndFocusFirstError(form: any) {
    form.markAllAsTouched();
    const firstInvalid = Object.keys(form.controls).find(k => form.get(k)?.invalid);
    if (firstInvalid) {
      const el = document.querySelector(`[formControlName="${firstInvalid}"]`) as HTMLElement | null;
      el?.focus();
    }
  }

  protected toastFormErrors(entity: string, form: FormGroup, labels?: FieldLabels, maxMsgs = 3) {
  form.markAllAsTouched();

  const msgs = collectFormMessages(form, labels);
  console.log(msgs)
  if (!msgs.length) return false;

  const body = msgs.slice(0, maxMsgs).join(' • ');
  const extra = msgs.length > maxMsgs ? ` (+${msgs.length - maxMsgs} más)` : '';
  this.toastServiceBase.show(`Revisa los datos para ${entity}: ${body}${extra}`, 'warning', 5000);

  const first = firstInvalidControlName(form);
  if (first) {
    const el = document.querySelector(`[formControlName="${first}"]`) as HTMLElement | null;
    el?.focus();
  }

  return true;
}

}
